import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatTimeHHMM'
})
export class FormatTimePipeHHMM implements PipeTransform {

  transform(value: number): string {
    if (value === null || value === undefined || isNaN(value)) return '';

    const hours = Math.floor(value);
    const minutes = Math.round((value - hours) * 60);

    // Garante que os minutos nunca sejam "60", o que causaria um erro
    if (minutes === 60) {
      return `${hours + 1}:00`;
    }

    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
  }

}

